module.exports = __webpack_public_path__ + "static/media/IMG_9985.b7b1e2eb.JPG";